const BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  close: ['far', 'xmark'],
  ellipsis: ['far', 'ellipsis'],
  pin: ['far', 'thumbtack'],
});

export default BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON;
